exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marginBottom[data-v-71bc36f6]{margin-bottom:32px}.resend-btn[data-v-71bc36f6]{display:inline-block;font-size:16px;color:#59d;border-bottom:1px dashed #59d;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71bc36f6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/templates/components/right-menu/ui/codeconfirm.vue
// module id = 523
// module chunks = 0